import type { GeneralConfig } from '@shared/types/Config';

export const stateConfig: GeneralConfig = {
    sortFieldMap: {
        'country.data.name': 'countries:country_id|countries.name',
    },
};
